<template>
  <v-row dense>
    <v-col cols="12">
      <v-card
        tile
        flat
        class="userBriefHistory"
        :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'"
      >
        <v-container>
          <v-row dense>
            <v-col v-for="(item, i) in clienttree?.hierarchy" :key="i">
              <p v-if="i === 0">Me ({{ item }})</p>
              <p v-else>> {{ item }} (L{{ i }})</p>
            </v-col>

            <v-col cols="12">
              <v-sheet
                class="d-flex align-center mb-4 justify-space-between flex-column flex-sm-row"
                :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'transparent'"
              >
                <div class="title">
                  <v-img
                    class="mr-3"
                    max-width="17"
                    src="@/assets/Dashboard/bar.svg"
                  ></v-img>
                  <span>
                    {{
                      clienttree?.user_info?.fname +
                      " " +
                      clienttree?.user_info?.lname
                    }}
                    (ID:{{ clienttree?.user_info?.id }})</span
                  >
                </div>
                <div class="client-info-tips">
                  <p class="mb-0">
                    <span class="text--green">Total Clients:</span>
                    {{ clienttree?.totalClients }}
                  </p>
                </div>
              </v-sheet>
            </v-col>
            <v-col v-for="(client, i) in levelCountsArray" :key="client.id">
              <v-sheet
                :class="
                  $vuetify.theme.dark ? 'blue-lighten-1 ' : 'white-lighten-1'
                "
              >
                <v-card-text class="trade">
                  <div class="icon-wrapper">
                    <div class="icon-box">
                      <span
                        :style="{
                          backgroundColor: colors[i % colors.length],
                          color: 'white',
                          padding: '5px 10px',
                        }"
                      >
                        {{ i + 1 }}
                      </span>
                    </div>
                    <div class="icon-content">
                      <h3>Level {{ i + 1 }}</h3>
                      <span>Clients</span>
                    </div>
                  </div>
                  <p class="amount">{{ client }}</p>
                </v-card-text>
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { CLIENTTREE__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      colors: [
        "#307633", "#307676", "#436AA6", "#FF7BDA",
        "#FF6363", "#647630", "#7543B5", "#0E8CB4",
        "#50E18A", "#FFC163"
      ],
    };
  },

  computed: {
    ...mapState("clienttree", ["clienttree"]),
    levelCountsArray() {
      if (this.clienttree && this.clienttree.levelCounts) {
        return Object.values(this.clienttree.levelCounts);
      }
      return [];
    },
  },

  methods: {
    ...mapActions("clienttree", [CLIENTTREE__ACTIONS.CLIENTTREE]),
  },

  mounted() {
    this[CLIENTTREE__ACTIONS.CLIENTTREE]();
  },
};
</script>
